/***
 * 创建人：汪明洁
 * 时间：2019-03-19
 * 描述：对邮箱进行验证
 * 更新记录: 
 */
import { Directive} from "@angular/core"
import { Validator, AbstractControl, NG_VALIDATORS} from "@angular/forms"

@Directive({
  selector:"[validatorEmail]",
  providers:[{provide:NG_VALIDATORS,useExisting:ValidatorEmailDirective,multi:true}]
})
export class ValidatorEmailDirective implements Validator{
  constructor(){

  }
  validate(control:AbstractControl):{[property:string]:string}{
      let reg=/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-_.])+[A-Za-z\d]{2,4}$/;
      let email=control.value;
      if(!email){
        return null  //为空时,不校验
      }
      if(reg.test(email)){
         return null
      }else{
         return {email_message:"邮箱格式不匹配"}
      }
  }
}